export default {
  title: "Sprachagent-Transkripte",
  description:
    "Kiosk-Gespräche zur Produktprüfung. Es werden keine Geräte- oder Gästeidentitäten gespeichert.",
  empty: "Noch keine Transkripte.",
  loadError: "Transkripte konnten nicht geladen werden",
  detailLoadError: "Dieses Transkript konnte nicht geladen werden",
  selectPrompt: "Wähle ein Gespräch zum Lesen aus.",
  endedWith: {
    user_stop: "Vom Gast beendet",
    error: "Fehler",
    time_limit: "Zeitlimit",
  },
  meta: {
    language: "Sprache",
    duration: "Dauer",
    turns: "Turns",
    activities: "Empfohlene Aktivitäten",
    none: "Keine",
  },
  roles: {
    user: "Gast",
    assistant: "Agent",
    recommendations: "Empfohlen",
  },
} as const;
